import navlink_module_default from "./navlink.module.js";
import { NavLink } from "@mantine/core";
import { jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";

//#region src/components/nav-link/SideNavLink.tsx
const SideNavLink = ({ active, disabled, label, Icon, href, target, onClick, color = "primary", style, "data-testid": testId }) => {
	const baseProps = {
		active,
		disabled,
		label,
		leftSection: Icon && /* @__PURE__ */ jsx(Icon, { color }),
		onClick,
		classNames: navlink_module_default,
		variant: "subtle",
		color,
		"data-sidebar": true,
		"data-testid": testId,
		role: "menuitem",
		__vars: {
			"--nl-color": "var(--mantine-color-text)",
			"--nl-hover": `var(--mantine-color-${color}-0)`
		},
		style
	};
	if (href) return /* @__PURE__ */ jsx(NavLink, {
		...baseProps,
		component: Link,
		to: href,
		target
	});
	return /* @__PURE__ */ jsx(NavLink, { ...baseProps });
};

//#endregion
export { SideNavLink };